import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import TagsPage from "./TagsPage";

const SettingsPage = () => {
  return (
    <div className="flex-column width-full">
      <h1>
        <FontAwesomeIcon icon={faCog} className="settings-icon" /> Settings
      </h1>
      <br />
      <div className="card settings-card">
        <TagsPage />
      </div>
    </div>
  );
};

export default SettingsPage;
